import React, { useEffect, useRef, useState } from "react";

import PropTypes from "prop-types";

import Card from "../../components/Cards/Card";

import NativeObject from "../../components/NativeObject/NativeObject";
import { useSelections } from "../../context/Selections";

function OpportunityMobile({ app, config, filter }) {
  const { cards } = config.onePage;
  const { title, tooltip, customRadio, legends, comboCharts } = cards[0];
  const [alignment, setAlignment] = useState(filter);
  const [selectedYear, setSelectedYear] = useState("FY23");
  const { selections } = useSelections();

  useEffect(() => {
    if (selections.length) {
      const selection =
        selections.find((selection) => selection.qField === "Ano")
          ?.qSelected === "FY23" ?? false;
      setSelectedYear(selection ? "FY23" : "FY24");
    }
  }, [selections]);


  useEffect(() => {
    handleChange(filter);
  }, [filter]);

  const handleChange = async (newAlignment) => {
    await app.field("%Selecao_Prod").selectMatch(newAlignment);
    setAlignment(newAlignment);
  };
  return (
    <div className="app onePage">
      <div className="appContent">
        <div style={{ display: "flex", flexWrap: "wrap" }}>
          <Card
            exportTable
            app={app}
            exportTableId="rvPpA"
            header={{
              hardTitle: "Atingimento PDVs - " + alignment,
              tooltip: tooltip,
            }}
            style={{ width: "100%", height: "400px" }}
          >
            <NativeObject
              app={app}
              key="rvPpA"
              reference={{ id: "rvPpA" }}
              style={{ marginTop: "20px" }}
            />
          </Card>
        </div>
        <div style={{ display: "flex", flexWrap: "wrap" }}>
          <Card
            header={{
              hardTitle: "Quantidade de Positivações por SKU's",
              tooltip: tooltip,
            }}
            style={{
              width: "100%",
              height: "400px",
            }}
          >
            <NativeObject
              app={app}
              key="yrpwz"
              reference={{ id: "yrpwz" }}
              style={{ marginTop: "20px" }}
            />
          </Card>
          <Card
            header={{
              hardTitle: " PDV's Positivados Por Distribuidor",
              tooltip: tooltip,
            }}
            style={{
              width: "100%",
              height: "400px",
            }}
          >
            <NativeObject
              app={app}
              key="Asbpr"
              reference={{ id: "Asbpr" }}
              style={{ marginTop: "20px" }}
            />
          </Card>
        </div>
      </div>
    </div>
  );
}

OpportunityMobile.defaultProps = {
  app: null,
  config: {},
  filter: "",
};

OpportunityMobile.propTypes = {
  app: PropTypes.object,
  config: PropTypes.object,
  filter: PropTypes.string,
};

export default OpportunityMobile;
